import {getArea} from '@apps-common/geocorn-sdk/geom/cea';

import formatNumber, {
  DEFAULT_FORMAT,
  truncateNumber,
} from '../format-number/format-number.js';
import {
  acres,
  hectares,
  identity,
  squareFeet,
  squareKilometers,
  squareMiles,
  squareNauticalMiles,
} from '../conversions.js';
import {areaUnits} from '../../constants/index.js';

const conversionMap = {
  [areaUnits.metric.m2]: n => truncateNumber(identity(n)),
  [areaUnits.metric.km2]: n => truncateNumber(squareKilometers(n)),
  [areaUnits.metric.ha]: n => truncateNumber(hectares(n)),
  [areaUnits.usc.ft2]: n => truncateNumber(squareFeet(n)),
  [areaUnits.usc.mi2]: n => truncateNumber(squareMiles(n)),
  [areaUnits.usc.ac]: n => truncateNumber(acres(n)),
  [areaUnits.usc.nmi2]: n => truncateNumber(squareNauticalMiles(n)),
};

export const localizationMap = {
  [areaUnits.metric.m2]: 'common:unitFormat.squareMeters',
  [areaUnits.metric.km2]: 'common:unitFormat.squareKilometers',
  [areaUnits.metric.ha]: 'common:unitFormat.hectares',
  [areaUnits.usc.ft2]: 'common:unitFormat.squareFeet',
  [areaUnits.usc.mi2]: 'common:unitFormat.squareMiles',
  [areaUnits.usc.ac]: 'common:unitFormat.acres',
  [areaUnits.usc.nmi2]: 'common:unitFormat.squareNauticalMiles',
};

const formatArea = (
  polygon,
  unit = areaUnits.metric.m2,
  format = DEFAULT_FORMAT
) => {
  if (!conversionMap[unit]) {
    return '';
  }
  const squareMeters = getArea(polygon);
  return formatNumber(squareMeters, conversionMap[unit], format);
};

export default formatArea;
